function $a9cec9f5d2c68d09$export$cc0e7cb90ac4067f(file) {
    return new Promise((resolve, reject)=>{
        // load file as data url, then load as image
        const reader = new FileReader();
        reader.onload = function() {
            // load image
            const image = new Image();
            image.src = reader.result;
            image.onload = function() {
                resolve(image);
            };
            image.onerror = function() {
                reject(new Error(`Failed to load "${file.name}"`));
            };
        };
        reader.onerror = function() {
            reject(new Error(`Failed to load "${file.name}: ${reader.error}"`));
        };
        reader.readAsDataURL(file);
    });
}


function $905062cf1895f308$export$9b2ff4fb61b7dfca(images) {
    if (images.imageError) return images.imageError;
    else if (!images.image) return "Missing image file";
    else if (images.imageType == "grayscale" && !images.paletteImage) return "Missing palette file";
}


class $ffb8c23cfbad9968$export$2e2bcd8739ae039 {
    #colorCanvas;
    #colorCtx;
    #paletteCanvas;
    #paletteCtx;
    #grayCanvas;
    #grayCtx;
    #colorToIndex;
    constructor(params){
        this.#colorToIndex = {};
        const ctxOpt = {
            willReadFrequently: true
        };
        this.#colorCanvas = params.colorCanvas;
        this.#colorCtx = this.#colorCanvas.getContext("2d", ctxOpt);
        this.#paletteCanvas = params.paletteCanvas;
        this.#paletteCtx = this.#paletteCanvas.getContext("2d", ctxOpt);
        this.#grayCanvas = params.grayCanvas;
        this.#grayCtx = this.#grayCanvas.getContext("2d", ctxOpt);
        this.#bindPaletteCanvasListeners();
    }
    #bindPaletteCanvasListeners() {
        let canvas = this.#paletteCanvas;
        let mouseX = 0;
        let mouseDown = false;
        const resolveMousePosition = (event)=>{
            const boundingRect = canvas.getBoundingClientRect();
            const inverseScale = 256 / boundingRect.width;
            mouseX = Math.floor((event.clientX - boundingRect.left) * inverseScale);
        };
        canvas.addEventListener("mousedown", (event)=>{
            if (event.button != 0) return;
            resolveMousePosition(event);
            mouseDown = true;
        });
        document.body.addEventListener("mousemove", (event)=>{
            if (!mouseDown) return;
            let oldX = mouseX;
            resolveMousePosition(event);
            let newX = mouseX;
            if (oldX == newX) // no need to swap
            return;
            const paletteData = this.#paletteCtx.getImageData(0, 0, 256, 1);
            // get old colors
            const oldOffset = oldX * 4;
            const newOffset = newX * 4;
            const oldR = paletteData.data[oldOffset];
            const oldG = paletteData.data[oldOffset + 1];
            const oldB = paletteData.data[oldOffset + 2];
            const oldA = paletteData.data[oldOffset + 3];
            const oldHash = $ffb8c23cfbad9968$var$hashColor(oldR, oldG, oldB, oldA);
            const newR = paletteData.data[newOffset];
            const newG = paletteData.data[newOffset + 1];
            const newB = paletteData.data[newOffset + 2];
            const newA = paletteData.data[newOffset + 3];
            const newHash = $ffb8c23cfbad9968$var$hashColor(newR, newG, newB, newA);
            // swap indices
            if (this.#colorToIndex[oldHash] == oldX) this.#colorToIndex[oldHash] = newX;
            if (this.#colorToIndex[newHash] == newX) this.#colorToIndex[newHash] = oldX;
            // swap colors
            paletteData.data[oldOffset] = newR;
            paletteData.data[oldOffset + 1] = newG;
            paletteData.data[oldOffset + 2] = newB;
            paletteData.data[oldOffset + 3] = newA;
            paletteData.data[newOffset] = oldR;
            paletteData.data[newOffset + 1] = oldG;
            paletteData.data[newOffset + 2] = oldB;
            paletteData.data[newOffset + 3] = oldA;
            this.#paletteCtx.clearRect(0, 0, 256, 1);
            this.#paletteCtx.putImageData(paletteData, 0, 0);
            // recreate grayscale
            this.#renderGrayscale();
        });
        document.body.addEventListener("mouseup", ()=>{
            mouseDown = false;
        });
    }
    loadImages(input) {
        const image = input.image;
        this.#colorCanvas.width = image.width;
        this.#colorCanvas.height = image.height;
        this.#grayCanvas.width = image.width;
        this.#grayCanvas.height = image.height;
        if (input.imageType == "color") this.#colorCtx.drawImage(image, 0, 0);
        else this.#grayCtx.drawImage(image, 0, 0);
        if (input.paletteImage) this.#loadPalette(input.paletteImage);
        else this.#generatePalette();
        if (input.imageType == "color") this.#renderGrayscale();
        else this.#renderColor();
    }
    #loadPalette(image) {
        this.#paletteCtx.clearRect(0, 0, 256, 1);
        this.#paletteCtx.drawImage(image, 0, 0);
        const imageData = this.#paletteCtx.getImageData(0, 0, 256, 1);
        this.#colorToIndex = {};
        for(let i = 0; i < 1024; i += 4){
            const r = imageData.data[i];
            const g = imageData.data[i + 1];
            const b = imageData.data[i + 2];
            const a = imageData.data[i + 3];
            const hash = $ffb8c23cfbad9968$var$hashColor(r, g, b, a);
            if (this.#colorToIndex[hash] == undefined) this.#colorToIndex[hash] = i / 4;
        }
    }
    #generatePalette() {
        const width = this.#colorCanvas.width;
        const height = this.#colorCanvas.height;
        const imageData = this.#colorCtx.getImageData(0, 0, width, height);
        this.#colorToIndex = {
            [0]: 0
        };
        let uniqueColors = 0;
        this.#paletteCtx.clearRect(0, 0, 256, 1);
        for(let i = 0; i < width * height * 4; i += 4){
            const r = imageData.data[i];
            const g = imageData.data[i + 1];
            const b = imageData.data[i + 2];
            const a = imageData.data[i + 3];
            const hash = $ffb8c23cfbad9968$var$hashColor(r, g, b, a);
            if (hash != 0 && this.#colorToIndex[hash] == undefined) {
                uniqueColors += 1;
                this.#colorToIndex[hash] = uniqueColors;
                this.#paletteCtx.fillStyle = `rgba(${r}, ${g}, ${b}, ${a / 255})`;
                this.#paletteCtx.fillRect(uniqueColors, 0, 1, 1);
            }
        }
    }
    #renderGrayscale() {
        const width = this.#colorCanvas.width;
        const height = this.#colorCanvas.height;
        const imageData = this.#colorCtx.getImageData(0, 0, width, height);
        for(let i = 0; i < width * height * 4; i += 4){
            const r = imageData.data[i];
            const g = imageData.data[i + 1];
            const b = imageData.data[i + 2];
            const a = imageData.data[i + 3];
            const hash = $ffb8c23cfbad9968$var$hashColor(r, g, b, a);
            const colorIndex = this.#colorToIndex[hash];
            imageData.data[i] = colorIndex;
            imageData.data[i + 1] = colorIndex;
            imageData.data[i + 2] = colorIndex;
            imageData.data[i + 3] = colorIndex == 0 ? 0 : 255;
        }
        this.#grayCtx.clearRect(0, 0, width, height);
        this.#grayCtx.putImageData(imageData, 0, 0);
    }
    #renderColor() {
        const width = this.#colorCanvas.width;
        const height = this.#colorCanvas.height;
        const imageData = this.#grayCtx.getImageData(0, 0, width, height);
        const paletteData = this.#paletteCtx.getImageData(0, 0, 256, 1);
        for(let i = 0; i < width * height * 4; i += 4){
            const colorI = imageData.data[i] * 4;
            imageData.data[i] = paletteData.data[colorI];
            imageData.data[i + 1] = paletteData.data[colorI + 1];
            imageData.data[i + 2] = paletteData.data[colorI + 2];
            imageData.data[i + 3] = paletteData.data[colorI + 3];
        }
        this.#colorCtx.clearRect(0, 0, width, height);
        this.#colorCtx.putImageData(imageData, 0, 0);
    }
}
function $ffb8c23cfbad9968$var$hashColor(r, g, b, a) {
    if (a == 0) return 0;
    return r << 24 | g << 16 | b << 8 | a;
}


const $b4e14b6b8da86996$var$imageTypeDialogElement = document.getElementById("image-type-dialog");
const $b4e14b6b8da86996$var$workspace = new (0, $ffb8c23cfbad9968$export$2e2bcd8739ae039)({
    paletteCanvas: document.getElementById("palette"),
    colorCanvas: document.getElementById("color"),
    grayCanvas: document.getElementById("grayscale")
});
const $b4e14b6b8da86996$var$pendingImages = {};
function $b4e14b6b8da86996$var$logError(error) {
    console.error(error);
    alert(error);
}
document.body.addEventListener("dragover", (event)=>event.preventDefault());
document.body.addEventListener("drop", (event)=>{
    const items = event.dataTransfer?.items;
    if (!items) return;
    event.preventDefault();
    const files = [];
    for (const item of items){
        const file = item.getAsFile();
        if (file) files.push(file);
    }
    $b4e14b6b8da86996$var$loadFiles(files).catch($b4e14b6b8da86996$var$logError).finally(()=>{
        $b4e14b6b8da86996$var$tryLoadPending();
    });
});
function $b4e14b6b8da86996$var$tryLoadPending() {
    const errorMessage = (0, $905062cf1895f308$export$9b2ff4fb61b7dfca)($b4e14b6b8da86996$var$pendingImages);
    const errorElement = document.getElementById("error");
    errorElement.innerText = errorMessage || "";
    if (!errorMessage && $b4e14b6b8da86996$var$pendingImages.imageType) {
        $b4e14b6b8da86996$var$workspace.loadImages($b4e14b6b8da86996$var$pendingImages);
        // reset palette image
        $b4e14b6b8da86996$var$pendingImages.paletteImage = undefined;
    }
}
async function $b4e14b6b8da86996$var$loadFiles(files) {
    for (const file of files){
        if (file.name.endsWith(".png")) try {
            const image = await (0, $a9cec9f5d2c68d09$export$cc0e7cb90ac4067f)(file);
            if (image.height == 1 && image.width == 256) $b4e14b6b8da86996$var$pendingImages.paletteImage = image;
            else {
                $b4e14b6b8da86996$var$pendingImages.image = image;
                $b4e14b6b8da86996$var$pendingImages.imageType = undefined;
            }
            $b4e14b6b8da86996$var$pendingImages.imageError = undefined;
        } catch (error) {
            console.error(error);
            $b4e14b6b8da86996$var$pendingImages.imageError = error.toString();
        }
    }
    if ($b4e14b6b8da86996$var$pendingImages.image && !$b4e14b6b8da86996$var$pendingImages.imageType) $b4e14b6b8da86996$var$imageTypeDialogElement.show();
}
function $b4e14b6b8da86996$var$createImageTypeSetter(type) {
    return function() {
        $b4e14b6b8da86996$var$pendingImages.imageType = type;
        $b4e14b6b8da86996$var$imageTypeDialogElement.close();
        $b4e14b6b8da86996$var$tryLoadPending();
    };
}
document.getElementById("set-color").onclick = $b4e14b6b8da86996$var$createImageTypeSetter("color");
document.getElementById("set-grayscale").onclick = $b4e14b6b8da86996$var$createImageTypeSetter("grayscale");


//# sourceMappingURL=index.0947f802.js.map
